module.exports = __webpack_public_path__ + "img/business.94610001.png";